import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  SUPPORTED_LOCALES,
  LOCALE_LABELS,
  type Locale,
  changeLocale,
  toLocale,
} from '@/i18n'

export interface UseLocaleResult {
  locale: Locale
  setLocale: (locale: Locale) => void
  locales: typeof SUPPORTED_LOCALES
  labels: typeof LOCALE_LABELS
}

export const useLocale = (): UseLocaleResult => {
  const { i18n } = useTranslation()

  const locale = toLocale(i18n.resolvedLanguage ?? 'en')

  const setLocale = useCallback((next: Locale) => {
    void changeLocale(next)
  }, [])

  return {
    locale,
    setLocale,
    locales: SUPPORTED_LOCALES,
    labels: LOCALE_LABELS,
  }
}
